if(!customElements.get('swym-wishlist-page')){
    class SwymWishlistPage extends HTMLElement{
        constructor(){
            super();
            this._initializeSwymComponent();
        }

        _init(swat){
            this._initializeSelectors(swat);
            this.isShareWishlistPage ? this._renderShareWishlist(swat) : this._renderWishlist(swat);
            this._attachEventListeners();
        }

        /* General funcions */

        _initializeSwymComponent(){
            if (!window.SwymCallbacks) window.SwymCallbacks = [];
            window.SwymCallbacks.push(this._init.bind(this));
        }

        _initializeSelectors (swat){
            this.swat = swat;
            this.body = document.body;
            this.settings = JSON.parse(this.dataset.settings);
            this.isShareWishlistPage = window.isShareListPage;

            /* Page Header Selectors */ 

            this.accountButton = this.querySelector('#swymcs-user-login-status-btn');
            this.accountPopup = this.querySelector('#swymcs-user-login-status-popup');
            this.accountPopupCloseButton = this.querySelector('#swymcs-close-account-popup');
            this.accountPopupCancelButton = this.querySelector('#swymcs-cancel-account-popup');
            this.accountPopupActionButton = this.querySelector('#swymcs-account-login-action-button');

            /* Wishlist grid container */
            this.emptyListContainer = this.querySelector('#swym-empty-wishlist-container'); 
            this.wishlistContainer = this.querySelector('#swymcs-wishlist-container');
            this.listsContainer = this.querySelector('#swymcs-lists-grid');
            this.listProductsContainer = this.querySelector('#swymcs-products-grid-container');
            this.productsContainer = this.querySelector('#swymcs-products-grid');
            this.wishlistHeader = this.querySelector('#swymcs-wishlist-header');
            this.backToListView = this.querySelector('#swymcs-back-to-lists-view');
            this.layoutToggleContainer = this.querySelector('#swymcs-layout-switcher');
            this.gridViewToggle = this.querySelector('#swymcs-grid-view-toggle');
            this.listViewToggle = this.querySelector('#swymcs-list-view-toggle');
            this.sortButton = this.querySelector('#swymcs-sort-products');
            this.swymAdditionOptionsContainer = this.querySelector('#swymcs-back-button-container');
            this.sortActiveOption = this.querySelector('#swymcs-active-sorting-option');
            this.revampedSortingOptionsContainer = this.querySelector('#swymcs-sorting-options-revamped'); 

            /* Lists header selectors */
            this.activeListContainer = this.querySelector('#swymcs-active-list');
            this.activeListImage = this.querySelector('#swymcs-active-list-image');
            this.activeListImageText = this.querySelector('#swymcs-active-list-image-text');
            this.activeListTilte = this.querySelector('#swymcs-active-list-title');
            this.activeListItemCount = this.querySelector('#swymcs-active-list-item-count');
            this.headerListsContainer = this.querySelector('#swymcs-header-lists');

            /* Additional Options selectors */ 

            this.additionalOptionsContainer = this.querySelector('#swymcs-additional-options');
            this.additionalOptionsBtn = this.querySelector('#swymcs-view-additional-options');
            this.shareListButton = this.querySelector('#swymcs-share-list');
            this.renameListButton = this.querySelector('#swymcs-rename-list');
            this.duplicateListButton = this.querySelector('#swymcs-duplicate-list');
            this.deleteListButton = this.querySelector('#swymcs-delete-list');

            /* Additional Options popup selectors */
            this.additionalOptionsPopupContainer = this.querySelector('#swymcs-additional-options-popup-container');
            this.additionalOptionsPopupCloseButton = this.querySelector('#swymcs-close-additional-popup');
            this.additionalPopupCancelButtons = this.querySelectorAll('.swymcs-additonal-popup-cancel-button');
            this.scrollControls = this.querySelector('.swymcs-scroll-controls');
            this.scrollUpButton = this.querySelector('#swymcs-scroll-up-button');
            this.scrollDownButton = this.querySelector('#swymcs-scroll-down-button');

                /* Share List popup selectors */ 
                this.shareListPopup = this.querySelector('#swymcs-share-list-popup');
                this.shareLinkField = this.querySelector('#swymcs-share-link-field');
                this.shareNameField = this.querySelector('#swymcs-share-name-field');
                this.shareEmailField = this.querySelector('#swymcs-share-email-field');
                this.shareMessageField = this.querySelector('#swymcs-share-message-field');
                this.shareListError = this.querySelector('#swymcs-share-email-field-error');
                this.shareListButton = this.querySelector('#swymcs-confirm-share-list');
                this.copyLinkButton = this.querySelector('#swymcs-confirm-share-list--copy');
                this.facebookShareButton = this.querySelector('#swymcs-confirm-share-list--facebook');
                this.twitterShareButton = this.querySelector('#swymcs-confirm-share-list--twitter');
                
                /* Delete List popup selectors */ 
                this.deleteListPopup = this.querySelector('#swymcs-delete-list-popup');
                this.deleteListName = this.querySelector('#swymcs-confirm-delete-list-name');
                this.confirmDeleteListButton = this.querySelector('#swymcs-confirm-delete-list'); 
                
                /* Rename List popup selectors */ 
                this.renameListPopup = this.querySelector('#swymcs-rename-list-popup');
                this.renameListName = this.querySelector('#swymcs-confirm-rename-list-name');
                this.renameListError = this.querySelector('#swymcs-rename-list-error');
                this.renameListTextField = this.querySelector('#swymcs-rename-list-field')
                this.confirmRenameListButton = this.querySelector('#swymcs-confirm-rename-list'); 

                /* Duplicate List popup selectors */ 
                this.duplicateListPopup = this.querySelector('#swymcs-duplicate-list-popup');
                this.duplicateListName = this.querySelector('#swymcs-confirm-duplicate-list-name');
                this.duplicateListError = this.querySelector('#swymcs-duplicate-list-error');
                this.duplicateListTextField = this.querySelector('#swymcs-duplicate-list-field');
                this.confirmDuplicateListButton = this.querySelector('#swymcs-confirm-duplicate-list'); 
        }

        _attachEventListeners(){

            this.body.addEventListener('click', evt => this._overlayEvent(evt));

            /* Adding events to page header elements */ 

            this.accountButton.addEventListener('click', evt => this._showPopupContainer(this.accountPopup));
            this.accountPopupCloseButton.addEventListener('click', evt => this._hidePopupContainer(this.accountPopup));
            this.accountPopupCancelButton.addEventListener('click', evt => this._hidePopupContainer(this.accountPopup));
            this.accountPopupActionButton.addEventListener('click', this._loginButtonAction.bind(this));

            /* Header Lists Events */
            
            this.activeListContainer.addEventListener('click', evt => this._showPopupContainer(this.headerListsContainer));
            this.headerListsContainer.addEventListener('click', this._switchListsFromHeader);

            /* Additional Options Events */     
            this.additionalOptionsBtn.addEventListener('click', evt => this._showPopupContainer(this.additionalOptionsContainer));   
            this.additionalOptionsContainer.addEventListener('click', this._renderAdditionalOptionsPopup);

            /* Additional Options Popup Events */
            this.additionalPopupCancelButtons.forEach(btn => btn.addEventListener('click', this._closeAdditionalOptionsPopup.bind(this)));
            this.additionalOptionsPopupCloseButton.addEventListener('click', this._closeAdditionalOptionsPopup.bind(this));
            this.scrollUpButton.addEventListener('click', () => {
                this._handleButtonInteraction(this.scrollUpButton, this._scrollUp.bind(this));
            });
            this.scrollDownButton.addEventListener('click', () => {
                this._handleButtonInteraction(this.scrollDownButton, this._scrollDown.bind(this));
            }); 

                /* Share List Events */
                this.copyLinkButton.addEventListener('click', this._shareListByCopy.bind(this));
                this.shareListButton.addEventListener('click', this._shareListByEmail.bind(this));
                this.facebookShareButton.addEventListener('click', evt => this._shareListOnPlatform('facebook'));
                this.twitterShareButton.addEventListener('click', evt => this._shareListOnPlatform('twitter'));
                this.shareEmailField.addEventListener('input', this._validateEmail.bind(this));

                /* Rename List Events */
                this.confirmRenameListButton.addEventListener('click', this._renameList.bind(this));
                this.renameListTextField.addEventListener('input', evt => this._validateListName(
                    this.renameListTextField.value.trim().toLowerCase(),
                    this.renameListError
                ))

                /* Duplicate List Events */
                this.confirmDuplicateListButton.addEventListener('click', this._duplicateList.bind(this));
                this.duplicateListTextField.addEventListener('input', evt => this._validateListName(
                    this.duplicateListTextField.value.trim().toLowerCase(),
                    this.duplicateListError
                ))

                /* Delete List Events */ 
                this.confirmDeleteListButton.addEventListener('click', this._deleteList.bind(this));

            /* Lists grid buttons */
            this.listsContainer.addEventListener('click', this._showListDetails);
            this.productsContainer.addEventListener('click', this._eventsForProductsGrid);
            this.productsContainer.addEventListener('change', this._eventsForProductsGrid);
            this.backToListView.addEventListener('click', this._triggerBackToListView.bind(this));
            !this.isShareWishlistPage && this._manageDragEvent();
            this.gridViewToggle.addEventListener('click', this._toggleLayout.bind(this));
            this.listViewToggle.addEventListener('click', this._toggleLayout.bind(this));
            this.sortButton.addEventListener('change', this._sortProducts.bind(this));
            this.sortActiveOption.addEventListener('click', this._showSortingOptions.bind(this));
            this.revampedSortingOptionsContainer.addEventListener('click', this._selectSortingOption.bind(this));

            this.gridViewToggle.dispatchEvent(new CustomEvent('click'))

            // Initialize scroll controls after everything is set up
            setTimeout(() => {
                this._initializeScrollControls();
            }, 100);
        }

        _toggleLayout(evt){
            const button = evt.currentTarget;
            if(button.classList.contains('active')) return; 

            const view = button.dataset.view;
            if(view == 'grid'){
                this.gridViewToggle.classList.add('active');
                this.layoutToggleContainer.classList.add('productgrid-gridview');
                this.listViewToggle.classList.remove('active');
                this.layoutToggleContainer.classList.remove('productgrid-listview');
            }else {
                this.gridViewToggle.classList.remove('active');
                this.listViewToggle.classList.add('active');
                this.layoutToggleContainer.classList.remove('productgrid-gridview');
                this.layoutToggleContainer.classList.add('productgrid-listview');
            }
        }

        _showSortingOptions(evt){
            this._showPopupContainer(this.revampedSortingOptionsContainer);
        }

        _selectSortingOption(evt){
            const sortingOption = evt.target;
            if(sortingOption.nodeName == 'UL') return;
            if(sortingOption.classList.contains('swymcs-active')) return;
            this.revampedSortingOptionsContainer.querySelector('.swymcs-active').classList.remove('swymcs-active');
            sortingOption.classList.add('swymcs-active');
            this.sortButton.value = sortingOption.dataset.sort;
            this.sortButton.dispatchEvent(new CustomEvent('change'));
            this._hidePopupContainer(this.revampedSortingOptionsContainer);
        }

        async _sortProducts(evt){
            if(window.productsDragged) await this._updateProductSequenceOfCurrentList();
            const sortValue = this.sortButton.value; 
            let sortText = ''
            let sortedProducts = [];

            switch (sortValue){
                case 'date_ascending': {
                    sortedProducts = await this._getSortedProducts(window.currentListProducts, 'cts', 'ascending');
                    sortText = 'Oldest to newest';
                    break;
                }
                case 'date_descending': {
                    sortedProducts = await this._getSortedProducts(window.currentListProducts, 'cts', 'descending');
                    sortText = 'Newest to oldest';
                    break;
                }
                case 'price_ascending': {
                    sortedProducts = await this._getSortedProducts(window.currentListProducts, 'pr', 'ascending');
                    sortText = 'Price, low to high';
                    break;
                }
                case 'price_descending': {
                    sortedProducts = await this._getSortedProducts(window.currentListProducts, 'pr', 'descending');
                    sortText = 'Price, high to low';
                    break;
                }
                case 'vendor_ascending': {
                    sortedProducts = await this._getSortedProducts(window.currentListProducts, 'bt', 'ascending');
                    sortText = 'Vendor, A-Z';
                    break;
                }
                case 'vendor_descending': {
                    sortedProducts = await this._getSortedProducts(window.currentListProducts, 'bt', 'descending');
                    sortText = 'Vendor, Z-A';
                    break;
                }
                default: {
                    sortedProducts = window.currentListProducts;
                }
            }
            this.sortActiveOption.textContent = sortText;
            this._renderProductsGrid(sortedProducts);
        }

        async _getSortedProducts(products, key, order) {
            return products.sort((a, b) => {
                if (typeof a[key] === "string" && typeof b[key] === "string") {
                    return order === "ascending" ? a[key].localeCompare(b[key]) : b[key].localeCompare(a[key]);
                } else { 
                    return order === "ascending" ? a[key] - b[key] : b[key] - a[key];
                }
            });
        }

        async _triggerBackToListView(){
            if(window.productsDragged) await this._updateProductSequenceOfCurrentList();
            this.sortButton.value = 'date_ascending';
            this._renderWishlist(_swat);
        }

        async _updateProductSequenceOfCurrentList(){
            const sequence = [];
            this.productsContainer.querySelectorAll('li').forEach((item, index) => {
                const obj = {'epi': item.dataset.epi, 'index': index + 1};
                sequence.push(obj);
            })
            const updatedSequence = await this._updateProductSequenceInList(sequence);
            await swymCustomFunctions._updateProductsCprops(updatedSequence, window.currentActiveListId);
        }

        _showListDetails(evt){
            const target = evt.target;
            const page = document.querySelector('swym-wishlist-page');
            if(target.getAttribute('id') != 'swymcs-lists-grid'){
                const lid = evt.target.closest('.swymcs-list-item').dataset.lid;
                const action = target?.dataset?.action || 'view-list';
                if(target.classList.contains('swymcs-view-list-button') && action == 'shop')
                    location.href = '/';
                else 
                page._renderListProducts(lid);   
            } return;  
        }
        
        async _renderWishlist(){
            this._visiblyHideContainer(this.backToListView);
            this.lists = await this._getLists();
            this.lists.length ? this._renderWishlists() : this._renderEmptyState();
        }

        async _renderShareWishlist(){
            this._hideContainer(this.querySelector('.swymcs-page-header'));
            const params = new URL(document.location).searchParams;
            const lid = params.get("lid");
            if(!lid){
                this._renderProductsGrid([]);
                this._hideContainer(this.swymAdditionOptionsContainer);
                this._hideContainer(this.wishlistHeader);
                this._visiblyHideContainer(this.backToListView)
                this._showContainer(this.wishlistContainer);
                this._showContainer(this.listProductsContainer);
                return;
            }
            const listContents = await this._getProductsFromList(lid);
            const wishlistProducts = swymCustomFunctions._getSortedProducts(listContents);
            const shopifyProductsData = await this._getShopifyProductsData(wishlistProducts);
            await this._renderSharedListHeader(lid);
            this._renderProductsGrid(shopifyProductsData);
            this._visiblyHideContainer(this.backToListView)
            this._showContainer(this.swymAdditionOptionsContainer);
            this._showContainer(this.wishlistContainer);
            this._showContainer(this.listProductsContainer);
        }

        _renderWishlists() {
            this._renderListsView();
            this.emptyListContainer.classList.add('swym-hide-container');
            this.wishlistContainer.classList.remove('swym-hide-container');
        }

        _renderEmptyState(){
            this.emptyListContainer.classList.remove('swym-hide-container');
            this.wishlistContainer.classList.add('swym-hide-container');
        }

        async _renderListsView(){
            window.currentActiveListId = '';
            let html = ``;
            this.lists.forEach(list => {
                const listContents = list?.listcontents || [];

                let buttonText = !listContents.length ? 'Continue Shopping' : 'View List';
                let buttonAction = !listContents.length ? 'shop' : 'view-list';
                let imageHtml = `<div class="swymcs-list-image-container">`;
                if(listContents.length){
                    for(let i = 0; i < 3; i++){
                        if(listContents[i]){
                            imageHtml += `
                                <div class="swymcs-wishlist-image-wrapper">
                                    <img src="${listContents[i].iu}" alt="${listContents[i].dt}" class="swymcs-wishlist-image"/>
                                </div>`;
                        }
                    }
                    imageHtml += '</div>';
                }
                else imageHtml += ` <p class="swymcs-no-products-message">This is an empty list!</p></div>`;

                html += `
                    <button class="swymcs-button swymcs-list-item swymcs-wishlist-grid-item" data-lid="${list.lid}" aria-label="View list ${list.lname}" id="list--${list.lid}">
                        <div class="swymcs-list-title-container">
                            <div class="swymcs-list-title">${list.lname}</div>
                        </div>
                        <div class="swymcs-list-product-count-container">
                            <span class="swymcs-product-count">${listContents.length}</span>
                            <span class="swymcs-product-count-text">${listContents.length > 1 ? 'products' : 'product'}</span>
                        </div>
                        ${imageHtml}
                        <div class="swymcs-view-list-button button-primary swymcs-major-button" data-action="${buttonAction}" id="swymcs-view-list-button-${list.lid}" aria-label="${buttonText}">
                            ${buttonText}
                        </div>
                    </button>
                `;
            });
            this.listsContainer.innerHTML = html;
            this._showContainer(this.listsContainer);
            this._hideContainer(this.listProductsContainer);
            this._scrollToTop();
        }

        async _renderListProducts(lid){
            window.currentActiveListId = lid;
            const unsortedListContent = await this._getProductsFromList(lid);
            const wishlistProducts = swymCustomFunctions._getSortedProducts(unsortedListContent);
            const shopifyProductsData = await this._getShopifyProductsData(wishlistProducts);
            this._renderListHeader(lid);
            this._renderProductsGrid(shopifyProductsData);
            this._visiblyShowContainer(this.backToListView);
            shopifyProductsData.length
                ? this._showContainer(this.swymAdditionOptionsContainer)
                : this._hideContainer(this.swymAdditionOptionsContainer);
            this._hideContainer(this.listsContainer);
            this._showContainer(this.listProductsContainer);

            // Update scroll controls visibility after switching views
            setTimeout(() => {
                this._updateScrollControlsVisibility();
            }, 100);
        }

        async _renderSharedListHeader(lid){
            this.wishlistHeader.style.borderTop = '1px solid #c4c4c4';
            const activeList = await this._getListDetails(lid);
            this._renderActiveList(activeList.list);
            this.activeListContainer.style.pointerEvents = 'none';
            this._hideContainer(this.additionalOptionsBtn);
        }

        _renderListHeader(lid){
            const lists = this.lists; 
            const activeList = lists.find(list => list.lid == lid);
            this._renderActiveList(activeList);
            let html = ``;
            lists.forEach((list, index) => {
                const unsortedListContent = list?.listcontents || [];
                const listContents = swymCustomFunctions._getSortedProducts(unsortedListContent);
                if(listContents.length){
                    html += `
                    <li class="swymcs-header-list-item" data-lid="${list.lid}">
                        <img src="${listContents[0].iu}" alt="listContents[0].dt"/>
                        <span class="swym-list-item">${list.lname}</span>
                    </li>`
                }else {
                    html += `
                    <li class="swymcs-header-list-item" data-lid="${list.lid}">
                        <span class="swymcs-list-item-image-text">${list.lname[0]}</span>
                        <span class="swymcs-list-item">${list.lname}</span>
                    </li>`
                }
            })
            this.headerListsContainer.innerHTML = html;
        }

        _renderActiveList(list){
            const unsortedListContent = list?.listcontents || [];
            const listContent = swymCustomFunctions._getSortedProducts(unsortedListContent);
            this.activeListTilte.textContent = list.lname;
            this.activeListItemCount.textContent = `(${listContent.length})`;
            if(listContent.length){
                this.activeListImage.src = listContent[0].iu;
                this.activeListImage.alt = listContent[0].lname;
                this._hideContainer(this.activeListImageText);
                this._showContainer(this.activeListImage);
            }else {
                this.activeListImageText.textContent = list.lname[0];
                this.activeListImage.alt = listContent.lname;
                this._hideContainer(this.activeListImage);
                this._showContainer(this.activeListImageText);
            }
        }

        _sanitizeDescription(html){
            let description = new DOMParser().parseFromString(html, "text/html");
            return description.body.textContent || "";
        }

        _renderProductsGrid(shopifyProducts){
            if(!shopifyProducts.length) {
                this._renderEmptyList();
                return;
            }
            window.productsDragged = false;
            window.currentListProducts = [];
            let productMarkup = ``;
            shopifyProducts.forEach((pdp, index) => {
                if(!pdp) return;
                window.currentListProducts.push(pdp);
                const product = pdp.productData;
                const selectedVariant = product.variants.find(variant => variant.id === pdp.epi);
                if(!selectedVariant) return;
                const addToCartBtnText = selectedVariant.available ? (_swat.platform.isInDeviceCart(selectedVariant.id) ? `${this.settings.added_to_cart_text}` : `${this.settings.add_to_cart_text}`) : `${this.settings.sold_out_text}`;
                const inCart = _swat.platform.isInDeviceCart(selectedVariant.id) ? 'swymcs-product-in-cart' : '';
                const lid = pdp.lid;
                const isSoldOut = !selectedVariant.available ? 'swymcs-sold-out' : '';
                const imageSrc = selectedVariant?.featured_image?.src || product?.featured_image ||  pdp.iu; 
                const selectedVariantTitle = selectedVariant.title && selectedVariant.title.toLowerCase() != 'default title' ? ` / ${selectedVariant.title}` : '';
                const selectedVariantPrice = parseFloat(selectedVariant.price/100.00).toFixed(2);
                const selectedVariantCmpPrice = selectedVariant.compare_at_price &&  selectedVariant.compare_at_price != selectedVariant.price ? parseFloat(selectedVariant.compare_at_price/100.00).toFixed(2) : '';
                let isButtonDisabled = isSoldOut ? 'disabled': '';
                const imageSrc2 = product?.images[1] ? product?.images[1] : imageSrc;
                const productUrl = product.productUrl;
                const discountAmount = selectedVariantCmpPrice - selectedVariantPrice;
                const discountPercentage = parseInt((discountAmount * 100) / selectedVariantCmpPrice);
                const salesBadge = selectedVariantCmpPrice ? `
                    <span class="productitem__badge productitem__badge--sale" data-badge-sales="true">
                        <span data-badge-sales-single="true">
                            Save <span data-price-percent-saved="true">${discountPercentage}</span>%
                        </span>
                    </span>` : '';
                const description = this._sanitizeDescription(product.description || '');
                productMarkup += `
                    <li class="ss__result swymcs-wishlist-grid-item-container ${selectedVariantCmpPrice ? 'productitem--sale' : ''} productgrid--item imagestyle--cropped-medium productitem--emphasis show-actions--mobile" data-index="${pdp?.cprops?.index}" data-product-item="true" style="--base-height: auto; --open-height:auto;" id="wishlist-grid-item--${index}" data-url="${pdp.du}" data-lid="${lid}" data-epi="${pdp.epi}">
                        <div class="productitem" data-product-item-content="true" bis_skin_checked="1">
                            <div class="productitem__container" bis_skin_checked="1">
                                <div class="productitem__image-container" bis_skin_checked="1">
                                    <a class="productitem--image-link" href="${productUrl}" tabindex="-1" data-product-page-link="true">
                                        <figure class="productitem--image" data-product-item-image="true">
                                            ${imageSrc2 ? `<img src="${imageSrc2}" alt="${selectedVariant.title}" loading="lazy" class="productitem--image-alternate"/>` : ''}
                                            <img src="${imageSrc}" alt="${selectedVariant.title}" loading="lazy" class="productitem--image-primary"/>
                                            ${salesBadge}
                                        </figure>
                                    </a>
                                    <div class="swymcs-wl-action-cta-container">
                                        <button data-lid="${lid}" data-purpose="delete" data-epi="${selectedVariant.id}" data-empi="${product.id}" data-du="${pdp.du}" class="${this.isShareWishlistPage && 'swym-hide-container'} swymcs-has-after-css swymcs-product-delete-btn" aria-label="${this.settings.delete_product_from_list_text} ${product.title}">
                                            <span class="swym-icon">${this.settings.swym_delete_list_icon}</span>
                                        </button>
                                    </div>
                                </div>
                                <div class="productitem--info" bis_skin_checked="1">
                                    <div class="price productitem__price" bis_skin_checked="1">
                                        <div class="price__compare-at visible" data-price-compare-container="true" bis_skin_checked="1">
                                            <span class="visually-hidden">Original price</span>
                                            <span class="money price__compare-at--single" data-price-compare="true">${selectedVariantCmpPrice ? `${window.currencyCode}${selectedVariantCmpPrice}`: ''}</span>
                                        </div>
                                        <div class="price__current price__current--emphasize ${selectedVariantCmpPrice ? 'price__current--on-sale' : ''}" data-price-container="true" bis_skin_checked="1">
                                            <span class="visually-hidden">Current price</span>
                                            <span class="money" data-price="true">${window.currencyCode}${selectedVariantPrice}</span>
                                        </div>
                                    </div>
                                    <h2 class="productitem--title">
                                        <a href="${productUrl}" data-product-page-link="true">${product.title} ${selectedVariantTitle ? selectedVariantTitle : ''}</a>
                                    </h2>
                                    <div class="ss__sku" bis_skin_checked="1">SKU #${selectedVariant.sku}</div>
                                    <div class="productitem--description" bis_skin_checked="1">
                                        <div class="swymcs-product-description">${description.length > 150 ? description.slice(0, 150) + "..." : description}</div>
                                        <a href="${productUrl}" class="productitem--link" data-product-page-link="true">View full details</a>
                                    </div>
                                </div>
                                <div class="productitem--actions" data-product-actions="true" bis_skin_checked="1">
                                    <div class="productitem--listview-price" bis_skin_checked="1">
                                        <div class="price productitem__price" bis_skin_checked="1">
                                            <div class="price__compare-at visible" data-price-compare-container="true" bis_skin_checked="1">
                                                <span class="visually-hidden">Original price</span>
                                                <span class="money price__compare-at--single" data-price-compare="true">${selectedVariantCmpPrice ? `${window.currencyCode}${selectedVariantCmpPrice}`: ''}</span>
                                            </div>
                                            <div class="price__current price__current--emphasize ${selectedVariantCmpPrice ? `price__current--on-sale` : ''}" data-price-container="true" bis_skin_checked="1">
                                                <span class="visually-hidden">Current price</span>
                                                <span class="money" data-price="true">${window.currencyCode}${selectedVariantPrice}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="productitem--listview-badge" bis_skin_checked="1">
                                        ${salesBadge}
                                    </div>
                                    <div class="productitem--action atc--button" bis_skin_checked="1">
                                        <button ${isButtonDisabled} data-purpose="cart" class="${isButtonDisabled ? 'swymcs-cart-disabled' : ''} swymcs-has-after-css productitem--action-trigger productitem--action-atc button-primary" type="button" aria-label="${addToCartBtnText}" data-variant-id="${selectedVariant.id}">
                                            ${addToCartBtnText}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                `;
            });
            this.productsContainer.innerHTML = productMarkup;
            this._scrollToTop();

            // Update scroll controls visibility after rendering products
            setTimeout(() => {
                this._updateScrollControlsVisibility();
            }, 100);
        }

        _renderEmptyList(){
            this.productsContainer.innerHTML = window.emptyListContent;
            this.productsContainer.querySelector('#swym-empty-wishlist-container').classList.remove('swym-hide-container');
        }

        async _renderAdditionalOptionsPopup (evt) {
            const page = document.querySelector('swym-wishlist-page');
            const target = evt.target;
            if(target.id == 'swymcs-additional-options') return; 
            page._hidePopupContainer(page.querySelector('.swym-active-popup'));
            const action = target.dataset.action; 
            page._closeAdditionalOptionsPopup();
            if(action == 'share') page._renderShareList();
            else if(action == 'rename') page._renderRenameList();
            else if(action == 'duplicate') page._renderDuplicateList();
            else if(action == 'delete') page._renderDeleteList();
            if(window.productsDragged) await page._updateProductSequenceOfCurrentList();
        }

        _closeAdditionalOptionsPopup () {
            this._hideContainer(this.shareListPopup);
            this._hideContainer(this.renameListPopup);
            this._hideContainer(this.duplicateListPopup);
            this._hideContainer(this.deleteListPopup);
            this._hidePopupContainer(this.additionalOptionsPopupContainer);
        }

        async _renderShareList() {
            const list = await this._markListAsPublic();
            const shareableLink = await this._prepareShareLink(list);
            this.shareLinkField.textContent = shareableLink;
            this._showContainer(this.shareListPopup);
            this._showPopupContainer(this.additionalOptionsPopupContainer);
        }

        _renderRenameList () {
            this.renameListName.textContent = this.activeListTilte.textContent;
            this.renameListTextField.value = this.activeListTilte.textContent;
            this.renameListTextField.placeholder = this.activeListTilte.textContent;
            this._showContainer(this.renameListPopup);
            this._showPopupContainer(this.additionalOptionsPopupContainer);
        }

        _renderDuplicateList () {
            this.duplicateListName.textContent = this.activeListTilte.textContent;
            this.duplicateListTextField.value = 'Copy Of ' + this.activeListTilte.textContent;
            this.duplicateListTextField.placeholder = this.activeListTilte.textContent;
            this._showContainer(this.duplicateListPopup);
            this._showPopupContainer(this.additionalOptionsPopupContainer);
        }

        _renderDeleteList () {
            this.deleteListName.textContent = this.activeListTilte.textContent;
            this._showContainer(this.deleteListPopup);
            this._showPopupContainer(this.additionalOptionsPopupContainer);
        }

        /* Show / Hide containers */

        _overlayEvent(evt){
            if (evt.target.nodeName == 'BODY') {
                this.querySelectorAll(".swym-active-popup").forEach(popup => this._hidePopupContainer(popup));
            }
        }

        _scrollToTop () {
            const header = document.querySelector('.swymcs-page-header');
            if (header) {
                var targetOffsetTop = header.getBoundingClientRect().top + window.scrollY;
                window.scrollTo({
                    top: targetOffsetTop,
                    behavior: "smooth"
                });
            }
        }

        _scrollUp() {
            const scrollAmount = window.innerHeight * 0.8; // Scroll 80% of viewport height
            const currentScrollTop = window.pageYOffset;
            const newScrollTop = Math.max(0, currentScrollTop - scrollAmount);

            window.scrollTo({
                top: newScrollTop,
                behavior: 'smooth'
            });

            // Update button states after a short delay
            setTimeout(() => {
                this._updateScrollButtonStates();
            }, 100);
        }

        _scrollDown() {
            const scrollAmount = window.innerHeight * 0.8; // Scroll 80% of viewport height
            const currentScrollTop = window.pageYOffset;
            const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
            const newScrollTop = Math.min(maxScroll, currentScrollTop + scrollAmount);

            window.scrollTo({
                top: newScrollTop,
                behavior: 'smooth'
            });

            // Update button states after a short delay
            setTimeout(() => {
                this._updateScrollButtonStates();
            }, 100);
        }

        _handleButtonInteraction(button, action) {
            // Add active class for visual feedback
            button.classList.add('swymcs-scroll-button-active');

            // Execute the scroll action
            action();

            // Remove active class after a short delay
            setTimeout(() => {
                button.classList.remove('swymcs-scroll-button-active');
            }, 150);
        }

        _initializeScrollControls() {
            if (!this.scrollControls) return;

            // Only show on mobile devices
            if (window.innerWidth > 767) {
                this.scrollControls.style.display = 'none';
                return;
            }

            this.scrollControls.style.display = 'flex';
            this._addScrollButtonIcons();
            this._updateScrollButtonStates();

            // Update visibility on resize
            window.addEventListener('resize', () => {
                this._initializeScrollControls();
            });
        }

        _addScrollButtonIcons() {
            if (!this.scrollUpButton || !this.scrollDownButton) return;

            // Add up arrow icon
            if (!this.scrollUpButton.querySelector('svg')) {
                const upArrowSvg = `
                    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 4l-8 8h16l-8-8z"/>
                    </svg>
                `;
                this.scrollUpButton.insertAdjacentHTML('beforeend', upArrowSvg);
            }

            // Add down arrow icon
            if (!this.scrollDownButton.querySelector('svg')) {
                const downArrowSvg = `
                    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 20l8-8H4l8 8z"/>
                    </svg>
                `;
                this.scrollDownButton.insertAdjacentHTML('beforeend', downArrowSvg);
            }
        }

        _updateScrollButtonStates() {
            if (!this.scrollUpButton || !this.scrollDownButton) return;

            const currentScrollTop = window.pageYOffset;
            const maxScroll = document.documentElement.scrollHeight - window.innerHeight;

            // Update up button state
            if (currentScrollTop <= 10) {
                this.scrollUpButton.classList.add('swymcs-scroll-button-disabled');
            } else {
                this.scrollUpButton.classList.remove('swymcs-scroll-button-disabled');
            }

            // Update down button state
            if (currentScrollTop >= maxScroll - 10) {
                this.scrollDownButton.classList.add('swymcs-scroll-button-disabled');
            } else {
                this.scrollDownButton.classList.remove('swymcs-scroll-button-disabled');
            }
        }

        _updateScrollControlsVisibility() {
            if (!this.scrollControls) return;

            const documentHeight = document.documentElement.scrollHeight;
            const windowHeight = window.innerHeight;

            // Only show if content is scrollable and on mobile
            if (documentHeight > windowHeight && window.innerWidth <= 767) {
                this.scrollControls.style.display = 'flex';
                this._updateScrollButtonStates();
            } else {
                this.scrollControls.style.display = 'none';
            }
        }

        _showPopupContainer (selector) {
            selector.classList.remove('swym-hide-container');
            selector.classList.add('swym-active-popup');
            this.body.classList.add('no-scroll');
        }

        _hidePopupContainer (selector) {
            selector.classList.add('swym-hide-container');
            selector.classList.remove('swym-active-popup');
            this.body.classList.remove('no-scroll');
        }

        _showContainer (selector) {
            selector.classList.remove('swym-hide-container');
        }

        _hideContainer (selector) {
            selector.classList.add('swym-hide-container');
        } 

        _visiblyHideContainer(selector){
            selector.classList.add('swym-visibily-hidden');
        }

        _visiblyShowContainer(selector){
            selector.classList.remove('swym-visibily-hidden');
        }

        /* Javascript APIs related functions */
        _getLists () {
            return new Promise(async (resolve, reject) => {
                this.swat.fetchLists({
                  callbackFn: lists => resolve(lists),
                  errorFn: err => reject(err)
                });
            });
        } 

        _getListDetails(lid){
            return new Promise(async (resolve, reject) => {
                this.swat.fetchListDetails(
                  { lid: lid },
                  list => resolve(list),
                  error => reject(error)
                );
            });
        }

        _getProductsFromList(lid){
            return new Promise(async (resolve, reject) => {
                this.swat.fetchListCtx(
                  { lid: lid },
                  listContents => resolve(listContents),
                  error => reject(error)
                );
            });
        }

        async _getShopifyProductsData(products){
            const section = this; 
            if(!products.length) return [];
            let buggedProductsArray = [];
            let response = await Promise.all(products.map(async (product) => {
                try{
                    const [storeUrlString, productHandleString] = product.du.split('/products/');
                    const productHandle = productHandleString.split('?')[0];
                    const reqURL = `${storeUrlString}${Shopify.routes.root}products/${productHandle}`;
                    const jsonData = await (await fetch(`${reqURL}.js`)).json();
                    jsonData.productUrl = `${storeUrlString}${Shopify.routes.root}products/${jsonData.handle}?variant=${product.epi}`;
                    product.productData = jsonData; 
                    return product;
                }
                catch(error){
                    const errorObj = {}; 
                    errorObj[product.du] = error; 
                    buggedProductsArray.push(errorObj);
                    return null; 
                }
            }));
            console.log('Products with bugs - ', buggedProductsArray);
            response = response.filter(product => product && product.productData);
            return response;
        }

        _deleteProductFromList(product, lid, parentNode){
            const onSuccess = async deletedProduct => {
                parentNode.remove();
                if(!this.productsContainer.querySelector('li')){
                    window.currentListProducts = [];
                    this._renderProductsGrid([]);
                    this._hideContainer(this.swymAdditionOptionsContainer);
                }
                window.currentListProducts = window.currentListProducts.filter(pdp => pdp.epi != product.epi);
                const lists = await this._getLists();
                const currentList = lists.filter(list => list.lid == lid);
                
                swymCustomFunctions._updateUnsortedLists(currentList);
            }
            const onError = error => console.log("Error while deleting the Product", error)
            this.swat.deleteFromList(lid, product, onSuccess, onError);
        }

        _renameList(){
            const listName = this.renameListTextField.value; 
            const isValidListName = this._validateListName(listName.trim().toLowerCase(), this.renameListError);
            if(!isValidListName) return;
            const listUpdateConfig = {
                "lid": window.currentActiveListId,
                "lname": listName,
                "lnote": ""
            };
            const onSuccess = async (updatedListObj) => {
                this._closeAdditionalOptionsPopup();
                this.lists = await this._getLists();
                this._renderListHeader(window.currentActiveListId);
            }
            const onError = error => console.log(`Error while Renaming the List, ${window.currentActiveListId}`, error);
            _swat.updateList(listUpdateConfig, onSuccess, onError);
        }

        _duplicateList(){
            const listName = this.duplicateListTextField.value; 
            const isValidListName = this._validateListName(listName.trim().toLowerCase(), this.duplicateListError);
            if(!isValidListName) return;
            const listConfig = {
                "lname": listName,
                "fromlid": window.currentActiveListId,
            };
            const onSuccess = async (listObj) => {
                this.lists = await this._getLists();
                this._renderListProducts(listObj.lid);
                this._closeAdditionalOptionsPopup();
            }
            const onError = error => console.log(`Error while duplicating the List, ${lid}`, error);
            _swat.createList(listConfig, onSuccess, onError);
        }

        _deleteList(){
            const onSuccess = deletedListObj => {
                this._closeAdditionalOptionsPopup();
                this._renderWishlist(_swat);
            }
            const onError = error => console.log(`Error while deleting the List, ${lid}`, error);
            _swat.deleteList(window.currentActiveListId, onSuccess, onError);
        }

        _validateListName(name, errorField){
            const isValidList = false;
            if(name.length < 3){
                errorField.textContent = 'Name must be longer than 3 characters';
                return isValidList; 
            }
            const lists = this.lists;
            const matchedList = lists.find(list => list.lname.trim().toLowerCase() == name);
            if(matchedList) {
                errorField.textContent = 'List name already exists';
                return isValidList;
            }
            errorField.textContent = '';
            return !isValidList;
        }

        _validateEmail() {
            const emailPattern = /^\w+([.-]\w+)*@\w+([.-]\w+)*(\.\w{2,4})+$/;
            const isBlank = this.shareEmailField.value=='' ? true : false;
            const isInvalidString = !this.shareEmailField.value.match(emailPattern) ? true : false;
            if(isBlank || isInvalidString){
                this.shareListError.textContent = isBlank ? 'Please enter the email address' : 'Please enter a valid email address';
                return false;
            }
            this.shareListError.textContent = '';
            return true;
        }

        _addProductToCart(button){
            const epi = +button.dataset.variantId;
            let formData = {
                'items': [{
                    'id': epi,
                    'quantity': 1
                }]
            };
               
            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
            .then(data => {
                button.classList.add('swymcs-product-in-cart');
                button.textContent = 'Added to cart'; 
                setTimeout(function(){
                    document.querySelector('.site-header-cart--button').dispatchEvent(new CustomEvent('click'));
                }, 100)
            })
            .catch(error => {
                button.textContent = 'Add to cart';
                button.removeAttribute('disabled');
                _swat.ui.uiRef.showErrorNotification({ message: error.description });
            }); 
        }

        _markListAsPublic(){
            return new Promise(async (resolve, reject) => {
                this.swat.markListPublic(window.currentActiveListId,
                    list => resolve(list),
                    err => reject(err)
                );
            });
        }

        _prepareShareLink(list){
            return new Promise(async (resolve, reject) => {
                this.swat.generateSharedListURL(list.lid,
                    (link, lid) => resolve(link, lid),
                    err => reject(err)
                );
            });
        }

        _shareListByCopy(){
            navigator.clipboard.writeText(this.shareLinkField.textContent)
            .then(() => _swat.ui.uiRef.showSuccessNotification({ message: 'Link Copied to Clipboard!' }))
            .catch(error => _swat.ui.uiRef.showErrorNotification({message: error.description}));
        }

        _shareListByEmail(){
            const email = this._validateEmail();
            if(!email) return;
            const onSuccess = response => {
                _swat.ui.uiRef.showSuccessNotification({message: 'List shared successfully over mail'});
                this._closeAdditionalOptionsPopup();
            }
            const onError = error => _swat.ui.uiRef.showErrorNotification({message: error.description});
            _swat.sendListViaEmail({
                'toEmailId': this.shareEmailField.value.trim(),
                'note': this.shareMessageField.value,
                'fromName': this.shareNameField.value,
                'lid': window.currentActiveListId,
            }, onSuccess, onError);
        }

        _shareListOnPlatform(platform){
            const shareUrl = this.shareLinkField.textContent;
            const note = this.shareMessageField.value;
            const fromName = this.shareNameField.value;
            const onError = error => _swat.ui.uiRef.showErrorNotification({message: error.description});
            let platformShareUrlTemplate = '';
            if(platform == 'facebook') 
                platformShareUrlTemplate = `https://www.facebook.com/sharer.php?u=${shareUrl}&t=${note}`;
            else if(platform == 'twitter')  
                platformShareUrlTemplate = `https://twitter.com/share?text=${note}&url=${shareUrl}`; 
            _swat.shareListSocial(window.currentActiveListId, fromName, platformShareUrlTemplate, platform, note, onError)
        }

        /* Header functions */

        _loginButtonAction(evt){
            const redirectionUrl = evt.currentTarget.getAttribute('data-redirection-url');
            const actionUrl = evt.currentTarget.getAttribute('data-action-url');
            localStorage.setItem('SWYM_REDIRECT_URL', redirectionUrl);
            localStorage.setItem('SWYM_ACTION_URL', actionUrl);
            location.href = actionUrl;
        }

        async _switchListsFromHeader (evt){
            const page = document.querySelector('swym-wishlist-page');
            const lid = evt.target.dataset.lid;
            if(window.productsDragged) await page._updateProductSequenceOfCurrentList();
            page._renderListHeader(window.currentActiveListId);
            page.sortButton.value = 'date_ascending';
            page._renderListProducts(lid);
            page._hidePopupContainer(page.headerListsContainer);
        }

        /* Product Grid Events */

        _manageDragEvent(){
            const sortable = new Sortable(this.productsContainer, {
                animation: 150, 
                onEnd: async (evt) => {
                    window.productsDragged = true;
                }
            });
        }

        async _updateProductSequenceInList(seq){ 
            const lid = window.currentActiveListId;
            const listProducts = await this._getProductsFromList(lid);
            const sequenceMap = {};
            seq.forEach(item => {
                sequenceMap[item.epi] = item.index;
            });
            listProducts.forEach(product => {
                const epi = product.epi;
                if (epi in sequenceMap) {
                    product.cprops = product.cprops || {};
                    product.cprops.index = sequenceMap[epi];
                }
            });
            return listProducts;
        }
        
        async _eventsForProductsGrid (evt) {
            const target = evt.target;
            if(target.id == 'swymcs-products-grid') return;
            const purpose = target.dataset.purpose;
            const page = document.querySelector('swym-wishlist-page');
            if(purpose == 'cart'){
                page._addProductToCart(target)
            }else if (purpose == 'delete'){
                page._deleteProductFromList(
                    {
                        "epi": target.dataset.epi,
                        "empi": target.dataset.empi,
                        "du": target.dataset.du
                    }, target.dataset.lid, target.closest('li')
                );
            } else if(purpose == 'link'){
                if(!page.isShareWishlistPage) await page._updateProductSequenceOfCurrentList();
                const url = target.dataset.url;
                location.href = url;
            }
        }

        /* Additional Options */


    }
    customElements.define('swym-wishlist-page', SwymWishlistPage);
}